<template>
    <Teleport v-if="parentDom" :to="parentDom">
        <div
            ref="markerRef"
            class="marker-house map-marker"
            :class="{ active: active === fmLatlng, hidden: data.destroyed || isShowMask }"
            @mouseenter="onMouseEnter"
            @mouseleave="onMouseLeave"
            @touchend="onClick"
            @click="onClick"
            @wheel.stop
            @mousewheel.stop
            v-bind="$attrs"
        >
            <span
                class="marker-shape"
                :class="[{ highlight: data.keepHighlight }, housesStatus]"
            >
                <template
                    v-if="
                        data.nodisclosureDes ||
                            hidePrice
                    "
                >&#xfe61;&#xfe61;&#xfe61;&#xfe61;&#xfe61;</template>
                <template
                    v-if="
                        !(data.nodisclosureDes ||
                            hidePrice ||
                            isShowMask)
                    "
                >
                    {{ showPrice }}
                </template>
            </span>
            <div
                ref="pop"
                class="marker-pop"
                :class="{ multi: houses.length > 1, bottom: popBottom }"
                :style="popStyle"
            >
                <div class="house-header" v-if="houses.length > 1">
                    <span class="iconfont icon-pinterest"></span>
                    <span>{{
                        $t('md-house.unitesHere', { count: houses.length })
                    }}</span>
                </div>
                <ul class="houst-list">
                    <li
                        class="house-item"
                        v-for="item in houses"
                        :key="item.id"
                    >
                        <a
                            :href="transformLink2WordPress(item.link)"
                            :target="item.detailUrlTarget"
                            rel="noopener noreferrer"
                        >
                            <div class="house-top">
                                <img-box
                                    class="img-container"
                                    :src="item.preview"
                                    :alt="item.address"
                                />
                                <div class="house-info">
                                    <p class="price" v-if="hideItemPrice(item)">
                                        Non-Disclosure
                                    </p>
                                    <p
                                        class="price"
                                        v-else-if="!item.nodisclosureDes"
                                    >
                                        {{
                                            showItemSoldPrice(item)
                                                ? item.soldPrice.replace(
                                                    /\s/g,
                                                    ''
                                                )
                                                : item.price.replace(/\s/g, '')
                                        }}
                                    </p>
                                    <p class="price" v-else>
                                        {{ item.nodisclosureDes }}
                                    </p>
                                    <i
                                        v-if="item.collected"
                                        class="iconfont icon-heart-fill"
                                    ></i>
                                    <div class="info">
                                        <span class="desc-span" v-for="it in item.basic" :key="it.key">{{ it.text }}</span>
                                    </div>
                                    <p class="addr">{{ item.streetAddress }}</p>
                                </div>
                            </div>
                            <div class="house-bottom">
                                <div class="detail">
                                    <p v-if="item.showMls" class="house-mls-id">
                                        MLS# {{ item.mlsid }}
                                    </p>
                                    <p
                                        v-if="!isShowMask && item.provided"
                                        class="house-provided"
                                    >
                                        {{ item.provided }}
                                    </p>
                                </div>
                                <site-img
                                    v-if="item.mlsLogo"
                                    class="house-mls-logo"
                                    :src="item.mlsLogo"
                                    alt="house mls logo"
                                    dir="height"
                                />
                            </div>
                        </a>
                        <house-mask
                            v-if="item.isProtected && !userEmailVerified"
                            :address="item.address"
                        />
                    </li>
                </ul>
            </div>
        </div>
    </Teleport>
</template>
<script>
import { mapState as rootMapState } from 'pinia';
import { useUserStore, usePageStore } from '@/store';
import { mapState } from '@/store/helpers';
import Marker from './marker';
import HouseFormat, { getBasic } from '@/common/house';
import HouseMask from '../../../modules/md-house/mask.vue';


export default {
    mixins: [Marker],
    data: function() {
        return {
            type: 'house',
            markerClassName: 'map-house-wrapper'
        };
    },
    components: {
        HouseMask
    },
    methods: {
        showItemSoldPrice(item) {
            return item.soldDate && item.showSoldPrice
        },
        hideItemPrice(item) {
            return !(this.house.showListingPrice || this.showItemSoldPrice(item)) && item.soldDate
        }
    },
    computed: {
        ...rootMapState(usePageStore, {
            "page": "processedGlobalData"
        }),
        ...rootMapState(useUserStore, {
            "userEmailVerified": "userEmailVerified"
        }),
        hidePrice({ house, houses }) {
            return !(house.showListingPrice || houses[0].showSoldPrice) && houses[0].soldDate
        },
        ...mapState(['result']),
        house({ page }) {
            return page?.house || {};
        },
        isShowMask() {
            let isVerified = this.userEmailVerified;
            return this.houses.length && this.houses[0].isProtected && !isVerified;
        },
        houses() {
            return this.data.items.map(item => {
                let house = HouseFormat.call(this, item, this.page);
                house.basic = getBasic.call(this, item);
                return house;
            });
        },
        housesStatus() {
            let houses = this.data.items;
            if (!houses.length) {
                return '';
            }
            let status = houses[0].listingStatus || '';
            return 'house-status-' + status.toLowerCase();
        }
    }
};
</script>
<style lang="scss">
.marker-house {
    &.hidden{
        display: none;
    }
    .house-item {
        position: relative;
    }
}
.house-item {
    .icon-heart-fill {
        display: none;
    }
}
</style>
